import React, { FC, useContext } from 'react';
import { Route, useRouteMatch } from 'react-router-dom';

import NavWrapper from '../components/wrappers/NavWrapper';
import InternalNavigation from '../components/InternalNavigation/InternalNavigation';
import { userContext } from '../utils/userContext';

export interface RouteLocationProps {
  page: number;
  selectedLocationId: number;
  selectedLocationName: string; 
  selectedDeviceId: number;
  selectedDeviceName: string;
}

export class RouteLocationProps implements RouteLocationProps {
  constructor(
    page: number = 0,
    selectedLocationId: number = 0,
    selectedLocationName: string = '',
    selectedDeviceId: number = 0,
    selectedDeviceName: string = ''
  ) {
    this.page = page;
    this.selectedLocationId = selectedLocationId;
    this.selectedLocationName = selectedLocationName;
    this.selectedDeviceId = selectedDeviceId;
    this.selectedDeviceName = selectedDeviceName;
  }
}

export interface CheckoutLocationProps extends RouteLocationProps{
  cardNumberData: string,
  cardNumberView: string,
  regNumber: string,
  ticket: string,
  checkoutTime: Date,
  dataId:number,
}

export class CheckoutLocationProps implements RouteLocationProps {
  constructor(
    page: number = 0,
    selectedLocationId: number = 0,
    selectedLocationName: string = '',
    cardNumberData: string = '',
    cardNumberView: string = '',
    regNumber: string = '',
    ticket: string = '',
    checkoutTime: Date = new Date(),
    selectedDeviceId: number = 0,
    selectedDeviceName: string = '',
    dataId: number = 0
  ) {
    this.page = page;
    this.selectedLocationId = selectedLocationId;
    this.selectedLocationName = selectedLocationName;
    this.selectedDeviceId = selectedDeviceId;
    this.selectedDeviceName = selectedDeviceName;
    this.cardNumberData = cardNumberData;
    this.cardNumberView = cardNumberView;
    this.regNumber = regNumber;
    this.ticket = ticket;
    this.checkoutTime = checkoutTime;
    this.dataId = dataId;
  }
}

const MobilbaseRouter: FC = () => {
  let match = useRouteMatch();
  const { hasModule } = useContext(userContext);

    return (
      <NavWrapper pageName="Mobilbase">
          {!hasModule(match.url) ?
              <Route component={() => <div>Du har ikke adgang til Mobilbase</div>}/>
          : 
            <InternalNavigation />
          }                 
      </NavWrapper>
    )
}

export default MobilbaseRouter;